module.exports = __webpack_public_path__ + "img/stop_alerts.png";